import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';

import { decryptDLoginBE } from '@/utils/func/encrypt';
import { gtmTrackEvent } from '@/utils/gtmTrackEvent';

const HeadC = dynamic(() => import('src/components/Head'));
const BabyGenerateJobsAi = dynamic(() => import('src/containers/SikecilJadiApa'), {ssr: false});

const SikecilJadiApa = () => {
	const router = useRouter();

	useEffect(() => {
		if (!router.isReady) return;

		const from = router.query.from;
		const dlogin = Cookies.get('d_login');

		let userData = null;

		if (typeof dlogin === 'string') {
			userData = decryptDLoginBE(dlogin);
		}

		let formattedDate = null;
		if (userData?.birthdate) {
			const d = new Date(userData.birthdate);
			if (!isNaN(d.getTime())) {
			formattedDate = d.toISOString().split('T')[0];
			}
		}

		let eventName = '';
		if (from === 'login') {
			eventName = 'login_success';
		} else if (from === 'register') {
			eventName = 'register_success';
		}

		if (!eventName || !userData) return;

		setTimeout(() => {
			gtmTrackEvent({
				event: eventName,
				uid: userData.uid,
				email: userData.email,
				birthdate: formattedDate,
				name: userData.name,
				phone_number: userData.phone_number,
				weight: userData.weight,
				height: userData.height,
				referral: userData.referal_code,
				phase: userData.web_phase_type,
			});
		}, 500);

	}, [router.isReady, router.query.from]);
	return (
		<>
			<HeadC
				title="Si Kecil Jadi Apa ?"
				description={
					'Hallobumil punya fitur baru yang bisa bantu Mama melihat potensi professi si Kecil berdasarkan cita-cita. ' +
					'Yuk, cek di sini!'
				}
			/>
			<BabyGenerateJobsAi />
		</>
	);
};

export default SikecilJadiApa;
